module.exports = "pegasus/assets/theme2/medium/5.jpg";